import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Link, withRouter } from 'react-router'
import classNames from 'classnames';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem, InputBin } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import { InputField } from '../Common/inputField';
import Radio from '../Common/radio';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'

let renderColor = props => {
  return (
    <div className="optionStyle">
      <Row><Col sm={ 12 }>{props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}</Col></Row>
      <Row>
        <Col sm = {1}></Col>
        <Col sm = {2}>
          <Input {...props.input} type="radio" value="Tomato" checked={props.input.value === "Tomato"} />
          <span style = {{color: 'Tomato'}}><Translate value="Red" /></span>
        </Col>
        <Col sm = {2}>
          <Input {...props.input} type="radio" value="MediumPurple" checked={props.input.value === "MediumPurple"} />
          <span style = {{color: 'MediumPurple'}}><Translate value="Purple" /></span>
        </Col>
        <Col sm = {2}>
          <Input {...props.input} type="radio" value="GoldenRod" checked={props.input.value === "GoldenRod"} />
          <span style = {{color: 'GoldenRod'}}><Translate value="Golden" /></span>
        </Col>
        <Col sm = {2}>
          <Input {...props.input} type="radio" value="MediumSeaGreen" checked={props.input.value === "MediumSeaGreen"} />
          <span style = {{color: 'MediumSeaGreen'}}><Translate value="Green" /></span>
        </Col>
        <Col sm = {2}>
          <Input {...props.input} type="radio" value="CornflowerBlue" checked={props.input.value === "CornflowerBlue"} />
          <span style = {{color: 'CornflowerBlue'}}><Translate value="Blue" /></span>
        </Col>
      </Row>
    </div>
  )
}

class BinForm extends Component {
    // static contextTypes = {
    //     router: React.PropTypes.object
    // };
    //
    // constructor() {
    //     super();
    //     this.state = {
    //         dirty: false
    //     };
    // }
    //
    // componentDidMount() {
    //     // making a leaving hook to confirm leaving
    //     this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    //
    //     if (this.props.currentBin) this.props.fetchBinDetail(this.props.currentBin);
    //     else if (this.props.currentZone) this.context.router.push("/warehouse");
    // }
    //
    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.dirty != this.props.dirty) {
    //         this.setState({
    //             dirty: nextProps.dirty
    //         });
    //     }
    // }
    //
    // routerWillLeave(nextLocation) {
    //     if (this.state.dirty) return <Translate value="work_not_saved_warning" />
    // }

    componentWillReceiveProps(nextProps) {
      if (nextProps.createError && !this.props.createError) {
        alert(nextProps.createError);
      }
      if (nextProps.editError && !this.props.editError) {
        alert(nextProps.editError);
      }
    }

    handleFormSubmit(formProps) {
        // this.setState({ dirty: false });
        const props = { ...formProps, Description: formProps.Description || '' };
        if (this.props.currentBin) {
          this.props.editBin(props);
        } else {
          this.props.createBin(props, this.props.currentWarehouse, this.props.currentZone);
        }
    }


    // title() {
    //     if (this.props.currentBin) return <Translate value="bin_detail_view" /> | <Translate value="edit_bin" />;
    //     else return <Translate value="bin_detail_view" /> | <Translate value="create_bin" />;
    // }

    checkPermission(permission) {
        return false;
    }

    render() {
        const { handleSubmit, closeG, submitting, pristine, valid } = this.props;
        return (
            <ContentWrapper>
                <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                  <br/>
                  <Row>
                    <Col sm={9}>
                      <Row>
                        <Col sm={2} />
                        <Col sm={8}>
                          <div className="form-group">
                              <label><em className="fa fa-building-o marginRightStyle"/><Translate value="bin_name" /> (*) </label>
                              <Field name="Name" component={ InputField } placeholder="Bin Name" />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={2} />
                        <Col sm={8}>
                          <div className="form-group">
                            <label><em className="fa fa-building-o marginRightStyle"/><Translate value="description" /> </label>
                            <Row><Col sm={12}><Field name="Description" component={InputField} className="form-control" /></Col></Row>
                          </div>
                          {/*
                            <Field component={Radio} title="At Inbound Area" name="IsAtInboundArea"/>
                            <Field component={Radio} title="At Outbound Area" name="IsAtOutboundArea"/>
                          */}
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={3}>
                      { this.props.isCreating || this.props.isEditing && <Spinner/> }
                      <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid || this.checkPermission("change_warehouse") } ><Translate value="save" /></button>
                      <Button onClick={closeG} bsStyle='warning' className="buttonStyle" ><Translate value="cancel" /></Button>
                    </Col>
                  </Row>
                  <Row>
                    {/* { this.props.createError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.createError)}</div> }
                    { this.props.editError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.editError)}</div> } */}
                  </Row>
                </form>
            </ContentWrapper>
        )
    }
}

export default withRouter(BinForm)



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/binForm.jsx